module.exports = __webpack_public_path__ + "static/media/Download_pdf.ab56a437.svg";